import { ThisConnector } from '../../../../api/connector'
import { mapNotification } from '../map-notification'
import { ApiNotification } from '../shared'
import { NotificationData } from '../../shared'

export interface GetNotificationsPageArgs {
  organizationUuid: string
  limit: number
  offset: number
}

export interface GetNotificationsPageResponse {
  notifications: NotificationData[]
  count: number
}

export async function getNotificationsPage(
  this: ThisConnector,
  { organizationUuid, limit, offset }: GetNotificationsPageArgs
) {
  const { notifications, count } = await this.connector.get<{
    notifications: ApiNotification[]
    count: number
  }>(
    `/${organizationUuid}/notifications?expand=skip_links&limit=${limit}&offset=${offset}`
  )

  return {
    notifications: notifications.map(mapNotification),
    count
  }
}
